import { Item } from 'baseui/side-navigation';
import { Key } from 'react';
import { useRecoilValue } from 'recoil';
import {
  FLEET_CATALOGS_PAGE_IDS,
  FLEET_CATALOGS_SECTION_ID,
  FLEET_OPERATIONAL_REPORTS_PAGE,
  FLEET_ROOT_PAGE_IDS,
  FLEET_SERVICE_REPORTS_PAGE,
} from '../constants/fleet';
import { pageState } from '../storage/app';
import { SidenavBlock } from '../types/app';
import { getPageNavKey } from '../utils/pages';

export function useFleetSidenavItems(items: Item[]) {
  const currentPage = useRecoilValue(pageState);
  const catalogItems = items.filter((item) => item.itemId && FLEET_CATALOGS_PAGE_IDS.includes(item.itemId));
  const reportsItem = items.filter(
    (item) => item.itemId && [FLEET_SERVICE_REPORTS_PAGE.id, FLEET_OPERATIONAL_REPORTS_PAGE.id].includes(item.itemId),
  );
  const missingItems = items.filter((item) => {
    const catalogIds = catalogItems.map((item) => item.itemId);
    const reportsIds = reportsItem.map((item) => item.itemId);
    return (
      item.itemId &&
      FLEET_ROOT_PAGE_IDS.includes(item.itemId) &&
      !catalogIds.includes(item.itemId) &&
      !reportsIds.includes(item.itemId)
    );
  });

  const pageSection: Key | undefined = (() => {
    const navKey = getPageNavKey(currentPage) ?? '';
    if (FLEET_CATALOGS_PAGE_IDS.includes(navKey)) {
      return FLEET_CATALOGS_SECTION_ID;
    }
  })();

  const mixedNav: SidenavBlock[] = [
    {
      type: 'flat',
      items: missingItems,
    },
    {
      type: 'section',
      id: FLEET_CATALOGS_SECTION_ID,
      title: 'Catálogos',
      items: catalogItems,
    },
    {
      type: 'flat',
      items: reportsItem,
    },
  ];

  return {
    pageSection,
    navigationBlocks: mixedNav.filter((block) => block.items.length > 0),
  };
}
